export function useCurrentJurisdiction() {
    return 'MGA';
}
